import DeviceAccessSettings from './DeviceAccessSettings';

export default DeviceAccessSettings;
